import {
  abacPoliciesSelector,
  ABACPolicyEntity,
  ABACPolicySelectorProps,
  useGetAllABACPoliciesQuery
} from "@ots-frontend/ots-data";
import {BaseABACPolicySelect, BaseABACPolicySelectProps} from "./BaseABACPolicySelect";
import {useCallback, useMemo, useState} from "react";
import {Button, Modal, ModalProps, Stack} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";

export type ABACPolicySelectProps = Omit<BaseABACPolicySelectProps, "entities" | "loading"> & {
  selector?: ABACPolicySelectorProps
}

export const ABACPolicySelect = (props: ABACPolicySelectProps) => {
  const {selector, ...rest} = props;

  const selectABACPolicies = useMemo(() => {
    return abacPoliciesSelector();
  }, []);

  const {abacPolicies, isLoading} = useGetAllABACPoliciesQuery(undefined, {
    selectFromResult: (result) => ({
      abacPolicies: selectABACPolicies(result),
      isLoading: result.isLoading
    })
  });

  return <BaseABACPolicySelect entities={abacPolicies} loading={isLoading} {...rest} />;
};

export interface ABACPolicySelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: Omit<ABACPolicySelectProps, 'label' | 'placeholder' | 'withinPortal' | 'clearable' | 'onEntityChange'>,
  onSubmit?: (sites: ABACPolicyEntity[] | undefined) => void
}

export const ABACPolicySelectModal = (props: ABACPolicySelectModalProps) => {
  const {
    select,
    onSubmit,
    ...rest
  } = props;

  const [selectedABACPolicies, setSelectedABACPolicies] = useState<ABACPolicyEntity[]>([])

  const {t} = useTranslation(["common"]);

  const form = useForm({
    initialValues: {
      abacPolicy: undefined,
    },
    validate: {}
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {
    if (onSubmit) {
      // noop
    }
  }, [form, onSubmit]);

  return (
    <Modal {...rest}>
      <form onSubmit={form.onSubmit(onFormSubmit)}>
        <Stack spacing="md">
          <ABACPolicySelect
            {...select}
            label={t("common.entity.abacpolicy", "ABAC Policy")}
            placeholder={t("common.entity.abacpolicy", "ABAC Policy")}
            withinPortal={true}
            clearable
            onEntityChange={e => setSelectedABACPolicies(e)}
            {...form.getInputProps("abacPolicy")} />
          <Button type="submit" mt="xl" onClick={(e) => {
            if (onSubmit) {
              onSubmit(selectedABACPolicies);
            }
          }}>
            {t("common.action.submit")}
          </Button>
        </Stack>
      </form>
    </Modal>
  );
};
